import Qs from "qs";
import request from "@/utils/request";

//1.登录接口 post
export const login = (data) => {
  return request({
    method: 'POST',
    url: '/h5AppLogin.htm',
    data: Qs.stringify(data)
  })
}

//微信自动登录
export const settingValue = () => {
  return request({
    method: 'GET',
    url: '/settingValue.htm?t=JYPACKAGE&k=wx_login_auto',
  })
}

// 添加收件人 
export const newaddReceiving = (data) => {
  return request({
    method: 'POST',
    url: '/saveCustomerConsignee.htm',
    data: Qs.stringify(data)
  })
}

// 修改收件人信息 
export const amendReceiving = (data) => {
  return request({
    method: 'POST',
    url: '/saveCustomerConsignee.htm',
    data: Qs.stringify(data)
  })
}

//获取收件人信息  
export const getReceiving = () => {
  return request({
    method: 'GET',
    url: '/customerConsigneeList.htm',
  })
}

//包裹设置
export const getPackageConfig = () => {
  return request({
    method: 'GET',
    url: '/getPackageConfig.htm',
  })
}

//根据id获取收件人
export const modifyReceiv = consigneeId => {
  return request({
    method: 'GET',
    url: '/loadCustomerConsignee.htm',
    params:{
      consigneeId
    }
  })
}

//验证登录
export const proof = () => {
  return request({
    method: 'GET',
    url: '/loginVerify.htm',
  })
}

//获取验证码
// export const verification = () =>{
//   return request ({
//     method:"GET",
//     url:""
//   })
// }

//表单提交登陆接口import request from "@/utils/request";
export const formLogin = (data) => {
  return request({
    method: 'POST',
    url: '/wx/confirmChooseLoginMode',
    data: Qs.stringify(data)
  })
}

//查询常用申报
export const getListCustomer = (data) => {
  return request({
    method: 'POST',
    url: '/listCustomerInvoice.htm',
    data: Qs.stringify(data)
  })
}

//修改常用申报
export const getUpdateCustomer = (data) => {
  return request({
    method: 'POST',
    url: '/updateCustomerInvoice.htm',
    data: Qs.stringify(data)
  })
}

//新增常用申报
export const getSaveCustomer = (data) => {
  return request({
    method: 'POST',
    url: '/saveCustomerInvoice.htm',
    data: Qs.stringify(data)
  })
}

//删除常用申报
export const getDeleteCustomer = (data) => {
  return request({
    method: 'POST',
    url: '/deleteCustomerInvoice.htm',
    data: Qs.stringify(data)
  })
}

//获取币种
export const getListCurrency = () => {
  return request({
    method: 'POST',
    url: '/listCurrency.htm',
  })
}

//获取单位
export const getListInvoiceunit = () => {
  return request({
    method: 'POST',
    url: '/listInvoiceunit.htm',
  })
}